import cardTransactionOccurrences from './cardTransactionOccurrences'
import occurrences from './occurrences'
import cardTransactions from './cardTransactions'

export default {
  install (Vue) {
    Vue.prototype.$api = {
      cardTransactionOccurrences: cardTransactionOccurrences,
      occurrences: occurrences,
      cardTransactions: cardTransactions
    }
  }
}
